var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('GainsTable',{attrs:{"data":_vm.gainsData}}),_vm._v(" "),_c('CostsForm',{ref:"costsForm",attrs:{"costs":_vm.costs,"initialCosts":_vm.simulation.initial_costs},on:{"restartSimulation":_vm.restartSimulation}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-081843ab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/EnergeticGains/Index.vue
// module id = mFxc
// module chunks = 1